<template>
	<nav v-if="total > 0 && total > pageSize">
		<ul class="pagination">
			<table-pagination-item>
				<button class="page-link" href="#" aria-label="Previous" @click.prevent="clickFirst">
					<span aria-hidden="true">«</span>
					<span class="sr-only">Previous</span>
				</button>
			</table-pagination-item>
			<table-pagination-item>
				<button class="page-link" href="#" aria-label="Previous" @click.prevent="clickPrevious">
					<span aria-hidden="true">‹</span>
					<span class="sr-only">Previous</span>
				</button>
			</table-pagination-item>

			<table-pagination-item v-for="item in pageItems" class="page-item" @click-index="clickIndex" :key="item" :isActive="item==currentPage" :value="item"></table-pagination-item>

			<table-pagination-item>
				<button class="page-link" href="#" aria-label="Next" @click.prevent="clickNext">
					<span aria-hidden="true">›</span>
					<span class="sr-only">Next</span>
				</button>
			</table-pagination-item>
			<table-pagination-item>
				<button class="page-link" href="#" aria-label="Next" @click.prevent="clickLast">
					<span aria-hidden="true">»</span>
					<span class="sr-only">Next</span>
				</button>
			</table-pagination-item>

		</ul>
		</nav>
</template>
<script>
	import TablePaginationItem from './TablePaginationItem'

	export default {
		name: 'TablePagination',
		components: {TablePaginationItem},
		props: {
			pageSize: Number, //items per page
			page: Number, //starting page number
			pages: Number, //number of buttons to show
			total: Number //number of items
		},
		data() {
			return {
				startPage: this.page || 1,
				currentPage: this.page || 1,
				pagesToShow: this.pages || 3
			}
		},
		computed: {
			totalPages() {
				const pages = Math.floor(this.total / this.pageSize);
				return (this.total % this.pageSize === 0) ? pages : pages + 1;
			},
			maximumPages() {
				let maximum = this.pagesToShow;

				//Ensure maximum pages isnt greater than available
				if (maximum > this.totalPages) maximum = this.totalPages;
				return maximum;
			},
			pageItems() {
				const items = [];
				let i=this.startPage;
				
				while (i <= this.startPage + this.maximumPages - 1) { 
					items.push(i);
					i++;
				} 

				return items;
			}
		},
		watch: {
  			page(value) {		
				let start = value;
				this.currentPage = start;

				if (start + this.pagesToShow > this.totalPages) start = this.totalPages - this.pagesToShow + 1
				this.startPage = start;	
			}
		},
		methods: {
			clickNext() {
				//Check if the current page can move along
				if (this.currentPage < this.totalPages) {
					this.currentPage += 1;
					this.$emit('page-changed', this.currentPage);
				}

				//Check if the current page is more than pages to show along from start page
				if (this.currentPage - this.maximumPages >= this.startPage) this.startPage++;				
			},
			clickPrevious() {
				if (this.currentPage > 1) {
					this.currentPage -= 1;
					this.$emit('page-changed', this.currentPage);
				}

				//Check if the current page is displayed
				if (this.currentPage < this.startPage) this.startPage--;
			},
			clickIndex(value) {
				this.currentPage = value;
				this.$emit('page-changed', this.currentPage);
			},
			clickFirst() {
				this.currentPage = 1;
				this.$emit('page-changed', this.currentPage);

				//Ensure current page is displayed
				this.startPage = 1;
			},
			clickLast() {
				this.currentPage = this.totalPages;
				this.$emit('page-changed', this.currentPage);

				//Modify start page so that last page is shown
				this.startPage = this.totalPages - this.pagesToShow + 1;				
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/TablePagination.vue